import './AreaMiniCard.css';

import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fullImagePath, generateClassName } from '../../b2b-common/helpers';
import MoreButton from '../../b2b-common/MoreButton';
import { AutoStories, Delete, Edit, MoreVert } from '@mui/icons-material';
import { LoginContext } from '../../../App';
import { deleteArea } from '../../../services/b2b-plans-apiService';
import { B2BContentContext } from '../../layout/Layout';
import { showNotification } from '../../b2b-common/Notification';
import ConfirmationDialog from '../../b2b-common/ConfirmationDialog';
import LogbookModalFactory from '../../b2b-logbook/forms/LogbookModalFactory';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const AreaMiniCard = ({ area, className = null, from = null, onDelete = null }) => {

    const { t } = useB2BTranslation('b2b-plans');
    const { setNotification } = useContext(B2BContentContext);
    const { loginData } = useContext(LoginContext);

    const [currentArea, setCurrentArea] = useState(area);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [showLogbookModal, setShowLogbookModal] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        setCurrentArea(area);
    }, [area]);

    const handleEditArea = () => {
        // console.log('Edit area clicked');
        navigate(`/plans/plans-explorer/${area.plan.planUUID}/areaEdit`, { state: { plan: area.plan, area, from } });
    }

    const handleDeleteArea = () => {
        //console.log('Delete area clicked');
        setIsConfirmationOpen(true);
    }

    const handleDeleteConfirmation = async () => {
        try {
            await deleteArea(loginData.accessToken, area.plan.planUUID, area.areaId);
            // console.log('deleteArea response:', response);
            showNotification(setNotification, t('Area deleted successfully'), 'success', 3000);
            onDelete && onDelete(area.areaId);
        } catch (error) {
            console.error('deleteArea error:', error);
            showNotification(setNotification, t('Error deleting area: ') + error.message, 'error', 3000);
        } finally {
            setIsConfirmationOpen(false);
        }
    }

    return (
        <div className={generateClassName('area-mini-card', '-container', className)}>
            <div className={generateClassName('area-mini-card', '-image', className)}>
                <img src={fullImagePath(area.imagePath)} alt={area.areaName} />
            </div>
            <div className={generateClassName('area-mini-card', '-content', className)}>
                <div className={generateClassName('area-mini-card', '-field', className)}>
                    {t('Area')}
                </div>
                <div className={generateClassName('area-mini-card', '-field-value', className)}>
                    {area.areaName}
                </div>
            </div>
            <div className={generateClassName('area-mini-card', '-actions', className)}>
                <MoreButton icon={<MoreVert />} buttons={[
                    {
                        label: t('Edit'),
                        icon: <Edit />,
                        onClick: handleEditArea,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                    },
                    {
                        label: t('Logbook'),
                        icon: <AutoStories />,
                        rolesAllowed: [],
                        b2bProducts: ['B2B_LOGBOOK'],
                        onClick: () => setShowLogbookModal(true)
                    },
                    {
                        label: t('Delete'),
                        icon: <Delete />,
                        onClick: handleDeleteArea,
                        rolesAllowed: ['ADMIN', 'EDITOR'],
                    },
                ]}
                    rolesAllowed={['ADMIN', 'EDITOR', 'USER']}
                    dropPositionAlign='left'
                    className='area-mini-card-more-button jb01-more-button'
                />
            </div>
            <LogbookModalFactory logbookRelatedEntity={currentArea} open={showLogbookModal}
                onClose={() => { setShowLogbookModal(false) }} />

            <ConfirmationDialog
                title={t('Area Delete Confirmation Request')}
                mainText={t('Are you sure you want to delete the selected area?')}
                open={isConfirmationOpen}
                onClose={() => setIsConfirmationOpen(false)}
                onConfirm={handleDeleteConfirmation}
            />
        </div>
    );
};

export default AreaMiniCard;